import React from 'react';
import MainLayout from '../../components/layout/MainLayout';
import { Mail, ShieldCheck } from 'lucide-react';
import { SEOHead } from '@/components/seo/SEOHead';
import { GovernedComplianceGrid } from '@/components/common/GovernedComplianceGrid';
import {
  COMPLIANCE_PAGE_INTRO,
  COMPLIANCE_PAGE_NOTICE,
  TERMS_OF_SERVICE_PATH,
} from '@/data/governedCompliance';

export default function CompliancePage() {
  return (
    <MainLayout>
      <SEOHead
        title="Compliance & Accreditations | Jigsaw Events Hub"
        description="View the governed compliance and accreditation record used across Jigsaw Events Hub, including certifications, registrations and framework participation."
        url="https://events.jigsawconferences.co.uk/compliance"
      />

      <section className="bg-[radial-gradient(circle_at_top_left,_rgba(249,115,22,0.16),_transparent_32%),linear-gradient(180deg,_#fff8f1_0%,_#ffffff_46%,_#f8fafc_100%)] px-4 py-20">
        <div className="mx-auto max-w-6xl space-y-8">
          <div className="max-w-4xl space-y-5">
            <div className="inline-flex rounded-full bg-orange-100 px-4 py-2 text-sm font-medium text-orange-800">
              <ShieldCheck className="mr-2 h-4 w-4" aria-hidden="true" />
              Governed compliance record
            </div>
            <h1 className="text-4xl font-bold text-slate-900 sm:text-5xl lg:text-6xl" data-testid="compliance-page-title">
              Compliance &amp; Accreditations
            </h1>
            <p className="text-base leading-8 text-slate-600" data-testid="compliance-page-intro">
              {COMPLIANCE_PAGE_INTRO}
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-8">
        <div className="mx-auto max-w-6xl rounded-[28px] border border-orange-100 bg-orange-50/70 p-6">
          <p className="text-sm leading-7 text-slate-700" data-testid="compliance-page-notice">
            {COMPLIANCE_PAGE_NOTICE}
          </p>
          <div className="mt-4 flex flex-wrap gap-3 text-sm">
            <a
              href="mailto:it@jigsawconferences.co.uk"
              className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 font-medium text-orange-800 shadow-sm transition-colors hover:text-orange-900"
              data-testid="compliance-contact-link"
            >
              <Mail className="h-4 w-4" aria-hidden="true" />
              Contact it@jigsawconferences.co.uk
            </a>
            <a
              href={TERMS_OF_SERVICE_PATH}
              className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 font-medium text-slate-700 transition-colors hover:border-slate-300 hover:text-slate-900"
              data-testid="compliance-terms-link"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </section>

      <section className="bg-slate-50 px-4 py-16">
        <div className="mx-auto max-w-6xl">
          <GovernedComplianceGrid variant="page" fallbackHref="/compliance" />
        </div>
      </section>

      <section className="bg-white px-4 pb-16">
        <div className="mx-auto max-w-4xl rounded-[28px] border border-slate-200 bg-slate-900 px-6 py-8 text-white">
          <h2 className="text-2xl font-semibold">Supporting information</h2>
          <p className="mt-3 text-sm leading-7 text-slate-300">
            Technical performance, accessibility testing and release QA may be presented elsewhere as platform-quality information, but must not be represented as regulatory or third-party certification.
          </p>
        </div>
      </section>
    </MainLayout>
  );
}
